import handler from 'api/handler'

const prefix = '/admin/purohit-on-call'

const methods = {
  create: args => handler({ method: 'post', url: `${prefix}/create`, args, headers: { 'Content-Type': 'multipart/form-data' } }),
  fetchAll: args => handler({ method: 'get', url: `${prefix}/fetch`, args }),
  updateStatus: args => handler({ method: 'post', url: `${prefix}/update-status`, args }),
  delete: id => handler({ method: 'delete', url: `${prefix}/delete/${id}` }),
}

export default methods
